module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('myheader')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "height": ".6rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-content"
  }, [_c('div', {
    staticClass: "report-title"
  }, [_c('p', {
    staticClass: "regcode"
  }, [_vm._v("检测单号："), _c('span', [_vm._v("15242525263625555")])]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/report.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "report-reginfo"
  }, [_c('h4', [_vm._v("\n                    检测基本信息\n                ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("姓名 : "), _c('b', [_vm._v("张天翼")])]), _vm._v(" "), _c('span', [_vm._v("性别 : "), _c('b', [_vm._v("女")])]), _vm._v(" "), _c('span', [_vm._v("年龄 : "), _c('b', [_vm._v("57岁")])])])]), _vm._v(" "), _c('div', {
    staticClass: "results"
  }, [_c('h4', [_vm._v("评估成绩")]), _vm._v(" "), _c('p', {
    staticClass: "first-p"
  }, [_c('span', [_vm._v("脑力值")]), _vm._v(" "), _c('span', [_vm._v("超过同龄人")]), _vm._v(" "), _c('span', [_vm._v("与同龄人相比")])]), _vm._v(" "), _c('p', {
    staticClass: "two-p"
  }, [_c('b', [_vm._v("62/100")]), _vm._v(" "), _c('b', [_vm._v("75%")]), _vm._v(" "), _c('b', [_vm._v("表现良好")])]), _vm._v(" "), _c('div', {
    staticClass: "results-img"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../assets/1.png")
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/2.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "jiedu-list"
  }, [_c('h4', [_vm._v("成绩解读")]), _vm._v(" "), _c('ul', [_c('li', [_c('h6', [_vm._v("检测基本信息")]), _vm._v(" "), _c('p', [_vm._v("\n                            您的综合能力表现良好，超过了70%的同龄人，请注意扬长避短，发挥优势，通过适当的认知训练保持优势的能力，提升弥补能力，保持大脑健康。\n                        ")])]), _vm._v(" "), _c('li', [_c('h6', [_vm._v("强弱项分析")]), _vm._v(" "), _c('p', [_vm._v("\n                            您的综合能力表现良好，超过了70%的同龄人，请注意扬长避短，发挥优势，通过适当的认知训练保持优势的能力，提升弥补能力，保持大脑健康。\n                        ")])]), _vm._v(" "), _c('li', [_c('h6', [_vm._v("专家建议")]), _vm._v(" "), _c('p', [_vm._v("\n                            您的综合能力表现良好，超过了70%的同龄人，请注意扬长避短，发挥优势，通过适当的认知训练保持优势的能力，提升弥补能力，保持大脑健康。\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "report-footer"
  }, [_c('p', [_vm._v("检测日期 : "), _c('span', [_vm._v("2017年3月21日 ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    六六脑 脑能力检测系统\n                ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": ".7rem"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9aee85c4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/phonecomponents/report.vue
// module id = 769
// module chunks = 1